import type { WikiEditConflict } from "./editor/wiki-edit-state";
import type { WikiRevisionPublic } from "@softmax/observatory-client/types";
import type { WikiRevision, WikiLoadState } from "@softmax/web-ux/wiki";

export function revisionView(revision: WikiRevisionPublic): WikiRevision {
  const author = revision.author;
  return {
    id: revision.id,
    body: revision.body,
    note: revision.note,
    createdAt: revision.created_at,
    author: {
      id: author.type === "user" ? author.user_id : author.player_id,
      displayName: author.name,
      kind: author.type,
    },
  };
}

export function loadState<T>({
  data,
  fetching,
  error,
}: {
  data: T | undefined;
  fetching: boolean;
  error: Error | null;
}): WikiLoadState<T> {
  if (data === undefined) {
    return error && !fetching
      ? { status: "error", message: error.message }
      : { status: "loading" };
  }

  const refresh = fetching
    ? { status: "loading" as const }
    : error
      ? { status: "error" as const, message: error.message }
      : { status: "idle" as const };
  return { status: "ready", data, refresh };
}

export function conflictView(conflict: WikiEditConflict) {
  return {
    baseBody: conflict.baseBody,
    currentBody: conflict.current_body,
    proposedBody: conflict.proposedBody,
  };
}
